<template>
  <div>
    <div class="confirmation-name mb-2">
      <h4 class="checkout-h4">Você pagou com PIX</h4>
      <div class="confirmation-name__icons">
        <h3
          class="checkout-h3"
          :class="
            pixPaymentInfo.status === 'Aprovado'
              ? 'success--text'
              : 'atention--text'
          "
        >{{ pixPaymentInfo.status }}</h3>


    
        <svg
          class="alert-card__icon"
          v-if="pixPaymentInfo.status === 'Aprovado'"
          style="width:24px;height:24px"
          viewBox="0 0 24 24"
        >
          <path
            fill="#00a65a"
            d="M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2,4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
          />
        </svg>

        <v-icon class="alert-card__icon" v-else color="atention">error_outline</v-icon>
      </div>
    </div>
    <p v-if="$route.name === 'commissioner' && orderPdvData" class="grey--text">Valor do Pedido: {{ orderPdvData.valor_pendente * 100 | currency }}</p>
    <p v-else class="grey--text">
      Valor do Pedido: {{ productsTotal | currency }}
    </p>
  </div>
</template>

<script>
export default {
  computed: {
    pixPaymentInfo() {
      return this.$store.getters.postOrder;
    },
    orderPdvData() {
      return this.$store.getters.orderPdvData;
    },
    productsTotal() {
      if (this.isCardPaymentOption) {
        return this.$store.getters.totalAmount;
      }

      let total = 0;
      let somador = 0;
      this.cartProducts.forEach(p => {
        p.forEach(v => {
          somador += (v.valor + v.valor_conveniencia) * v.quantidade;
        });
      });
      total = somador;
      return total * 100;
    },
    cartProducts() {
      return this.$store.getters.cartProducts;
    },
  },
};
</script>
